import getIn from 'transmute/getIn';
export const getInboxes = getIn(['unifiedInbox', 'inboxes']);